import React from "react"
import styled from "styled-components"
import {Flex} from "../../../components/Flex"
import {Boundary} from "../../../components/Boundary"

const ReportFooter = () => {
  return (
    <OuterDiv>
      <Boundary>
        <LinksFlex>
          <LinkDiv>About</LinkDiv>
          <LinkDiv>Legal</LinkDiv>
          <LinkDiv>Privacy</LinkDiv>
          <LinkDiv>Cookies</LinkDiv>
          <LinkDiv>Linking policy</LinkDiv>
          <LinkDiv>Site provider</LinkDiv>
          <LinkDiv>Support</LinkDiv>
          <LinkDiv>Contact us</LinkDiv>
        </LinksFlex>
        <DescriptionDiv>
          © 2020 PwC. All rights reserved. PwC refers to the PwC network and/or
          one or more of its member firms, each of which is a separate legal
          entity. Please see www.pwc.com/structure for further details.
        </DescriptionDiv>
      </Boundary>
    </OuterDiv>
  )
}

const DescriptionDiv = styled.div`
  color: rgba(255, 255, 255, 0.6);
`

const LinkDiv = styled.div`
  color: white;
  padding: 0 1em;
`

const LinksFlex = styled(Flex)`
  font-weight: bold;
  justify-content: center;
  margin-bottom: ${(props) => props.theme.gutter}px;
`

const OuterDiv = styled.div`
  background-color: #464646;
  font-size: ${(props) => props.theme.fontSizeSmall}px;
  padding: ${(props) => props.theme.gutter * 2}px 0;
`

export {ReportFooter}
